import React, { FC } from "react";
import trainers from "../data/trainers";
import Trainer from "../components/Trainer";

const TrainersSection: FC = () => {
    return (
        <section className="trainers" id="trainers">
            <div className="trainers__title">
                <h3>Наші тренери</h3>
            </div>
            <div className="trainers__grid">
                {trainers.map(trainer => (
                    <Trainer 
                        name={trainer.name} 
                        photo={trainer.photo}
                        instagram={trainer.instagram}
                    />
                ))}
            </div>
        </section>
    );
};

export default TrainersSection;
